
    import { Component, Vue, Prop } from "vue-property-decorator";

    @Component({
    })
    export default class NotificationMsgPopUp extends Vue {

        @Prop()
        msgValue: any;

        @Prop()
        classFlag: any;

        calssName: string = "";
        iconName: string = "";
        btnClassName: string = "";
        headerText: string = "";
        notificationBody: string = "";
        notificationPopUpModalId: string = "";

        created() {
            if (this.classFlag == 'success') {
                this.calssName = 'neu-snackbar--success';
                this.iconName = 'check_circle';
                this.btnClassName = 'neu-button--success btnNotificationSuccess';
                this.headerText = 'Success';
                this.notificationBody = 'txtSuccessMsg';
                this.notificationPopUpModalId = 'SuccessPopup';
            }
            else if (this.classFlag == 'error') {
                this.calssName = 'neu-snackbar--error';
                this.iconName = 'error';
                this.btnClassName = 'neu-button--danger btnNotificationError';
                this.headerText = 'Alert';
                this.notificationBody = 'txtErrorMsg';
                this.notificationPopUpModalId = 'ErrorPopup';
            }
        }

        mounted() {
            var errorPopupElement = document.getElementById('ErrorPopup') as HTMLElement;
            var successPopupElement = document.getElementById('SuccessPopup') as HTMLElement;

            if(errorPopupElement != null){
                var errorPopupHeight = errorPopupElement.clientHeight + 20;
                if(successPopupElement != null){
                    successPopupElement.style.top = errorPopupHeight + "px";
                }
            }
        }

        closeButtonClicked() {
            this.$emit('closeModal')
        }
    }

